// Planning helpers (fees, deposit planner): pure, figures from /plan/*.

// feeImpact compounds the account for `years` at a gross yearly return,
// with and without the yearly cost (in % of the account). Contributions are
// left out: it isolates what the fees alone take.
export const feeImpact = (value, dragPct, grossPct = 6, years = 20) => {
  if (!(value > 0)) return null;
  const without = value * (1 + grossPct / 100) ** years;
  const withFees = value * (1 + (grossPct - dragPct) / 100) ** years;
  return { without, withFees, cost: without - withFees, years };
};

export const FEE_PARTS = [
  { key: 'trading_cost', label: 'Courtage', hint: 'Ordres des 12 derniers mois au barème saisi.' },
  { key: 'fx_cost', label: 'Change', hint: 'Ordres en devise étrangère.' },
  { key: 'fund_cost', label: 'Frais des ETF', hint: 'Frais courants prélevés dans la valeur des fonds.' },
  { key: 'withholding_cost', label: 'Retenues à la source', hint: 'Impôt étranger sur les dividendes, non récupérable dans un PEA.' },
  { key: 'custody_cost', label: 'Droits de garde', hint: 'Forfait annuel saisi.' },
];

export const DEPOSIT_REASONS = {
  no_amount: 'Indiquez le montant de votre versement mensuel.',
  no_targets: 'Définissez d’abord vos cibles ci-dessus : le versement est réparti vers les lignes sous leur cible.',
  ceiling_reached: 'Le plafond de versements de votre PEA est atteint : plus aucun versement n’est possible.',
  no_portfolio: 'Portefeuille indisponible : le courtier ne répond pas.',
  nothing_to_buy: 'Rien à acheter : aucune ligne n’est assez loin de sa cible pour un ordre au-dessus du minimum.',
};
